"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var asset_variant_1 = __importDefault(require("../../../shared/util/asset-variant"));
// Provides theme spacing, breakpoint values for the main theme to consume.
var basicTheme = styles_1.createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1440,
        },
    },
});
var paletteVariants = {
    gov: {
        type: 'light',
        divider: '#d8d8d8',
        primary: {
            main: '#023047',
            dark: '#035477',
            contrastText: '#fff',
        },
        secondary: {
            light: '#CDDCE0',
            main: '#8CA6AD',
            dark: '#2F4B62',
            contrastText: '#000',
        },
        text: {
            primary: '#023047',
            secondary: '#767676',
        },
        background: {
            default: '#f9f9f9',
            paper: '#ffffff',
        },
    },
    edu: {
        type: 'light',
        divider: '#d8d8d8',
        primary: {
            main: '#48426D',
            dark: '#2B2E4A',
            contrastText: '#fff',
        },
        secondary: {
            light: '#D5CDE0',
            main: '#8F8AB0',
            dark: '#2B2E4A',
            contrastText: '#000',
        },
        text: {
            primary: '#48426D',
            secondary: '#767676',
        },
        background: {
            default: '#f9f9f9',
            paper: '#ffffff',
        },
    },
    health: {
        type: 'light',
        divider: '#d8d8d8',
        primary: {
            main: '#6D4559',
            dark: '#472F40',
            contrastText: '#fff',
        },
        secondary: {
            light: '#F1D4DF',
            main: '#AB7F95',
            dark: '#472F40',
            contrastText: '#000',
        },
        text: {
            primary: '#6D4559',
            secondary: '#767676',
        },
        background: {
            default: '#f9f9f9',
            paper: '#ffffff',
        },
    },
};
var palette = paletteVariants[asset_variant_1.default];
exports.default = styles_1.responsiveFontSizes(styles_1.createTheme({
    breakpoints: basicTheme.breakpoints,
    palette: palette,
    typography: {
        fontFamily: "'Noto Sans Khmer', sans-serif",
        h1: {
            fontSize: '3.4375rem',
            fontWeight: 600,
            lineHeight: 1.182,
        },
        h2: {
            fontSize: '2.8125rem',
            fontWeight: 500,
            lineHeight: 1.267,
        },
        h3: {
            fontSize: '1.75rem',
            fontWeight: 600,
            lineHeight: 1.321,
        },
        h4: {
            fontSize: '1.375rem',
            fontWeight: 600,
            lineHeight: 1.364,
        },
        h5: {
            fontSize: '1.125rem',
            fontWeight: 700,
            lineHeight: 1.389,
        },
        h6: {
            fontSize: '1rem',
            fontWeight: 500,
            lineHeight: 1.3125,
        },
        subtitle1: {
            fontSize: '1.2rem',
            lineHeight: 1.5,
        },
        body1: {
            fontSize: '1rem',
            lineHeight: 1.5625,
        },
        body2: {
            fontSize: '0.875rem',
            fontWeight: 500,
            lineHeight: 1.429,
        },
        caption: {
            fontSize: '0.8125rem',
            lineHeight: 1.308,
            color: palette.text.secondary,
        },
        button: {
            textTransform: 'none',
        },
    },
    overrides: {
        MuiButton: {
            root: {
                borderRadius: '10px',
            },
            contained: {
                boxShadow: 'none',
                '&:hover': {
                    boxShadow: 'none',
                    backgroundColor: palette.primary.dark,
                },
                '&:active': {
                    boxShadow: 'none',
                    backgroundColor: palette.primary.dark,
                },
            },
            outlinedPrimary: {
                border: "1px solid " + palette.primary.main,
                backgroundColor: basicTheme.palette.common.white,
                '&:hover': {
                    backgroundColor: basicTheme.palette.grey[100],
                },
                '&:active': {
                    backgroundColor: palette.primary.main,
                    color: basicTheme.palette.common.white,
                },
                '&:disabled': {
                    color: '#bbb',
                    border: "1px solid #bbb",
                },
            },
        },
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: palette.background.default,
            },
        },
        MuiInputBase: {
            input: {
                fontSize: '14px',
            },
        },
        MuiOutlinedInput: {
            input: {
                '&:-webkit-autofill': {
                    // Override autofill background.
                    boxShadow: '0 0 0 100px #ffffff inset',
                },
            },
            notchedOutline: {
                // Must be same as InputLabel.
                fontSize: '16px',
            },
        },
        MuiInputLabel: {
            root: {
                fontSize: '16px',
            },
        },
        MuiLink: {
            root: {
                fontWeight: 500,
            },
        },
        MuiTooltip: {
            tooltip: {
                backgroundColor: palette.text.primary,
                fontSize: '0.8125rem',
            },
            arrow: {
                color: palette.text.primary,
            },
        },
        MuiTable: {
            root: (_a = {
                    overflowX: 'auto',
                    overflow: 'auto'
                },
                _a[basicTheme.breakpoints.down('sm')] = {
                    overflowX: 'hidden',
                    overflow: 'hidden',
                    display: 'block',
                },
                _a),
        },
        MuiTableCell: {
            root: {
                paddingTop: basicTheme.spacing(2),
                paddingBottom: basicTheme.spacing(2),
                paddingLeft: 0,
                paddingRight: basicTheme.spacing(4),
                borderBottom: "1px solid " + palette.divider + "60",
            },
            body: (_b = {
                    wordBreak: 'break-all'
                },
                _b[basicTheme.breakpoints.only('sm')] = {
                    paddingRight: '80px',
                },
                _b[basicTheme.breakpoints.down('sm')] = {
                    margin: 'auto 0',
                    fontSize: '16px',
                    borderBottom: 'none',
                    paddingBottom: '4px',
                    width: '70%',
                },
                _b),
        },
        MuiTableBody: {
            root: (_c = {},
                _c[basicTheme.breakpoints.down('sm')] = {
                    display: 'block',
                },
                _c),
        },
        MuiTableRow: {
            root: (_d = {},
                _d[basicTheme.breakpoints.down('sm')] = {
                    display: 'flex',
                    flexFlow: 'row wrap',
                    height: '352px',
                    padding: '5px 5px 0px',
                    border: 'solid 1px rgba(0, 0, 0, 0.15)',
                },
                _d),
        },
        MuiTablePagination: {
            toolbar: (_e = {
                    paddingRight: '80px'
                },
                _e[basicTheme.breakpoints.down('sm')] = {
                    padding: '0',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-evenly',
                },
                _e),
            selectRoot: (_f = {},
                _f[basicTheme.breakpoints.down('sm')] = {
                    margin: '0',
                },
                _f),
            actions: (_g = {},
                _g[basicTheme.breakpoints.down('sm')] = {
                    margin: '0',
                },
                _g),
        },
        MuiDivider: {
            root: {
                backgroundColor: '#e8e8e8',
            },
        },
    },
}));
